import React from 'react'
import { FeaturesSection } from '../components/Home/FeaturesSection'
import { LastSection } from '../components/Home/LastSection'
import { WelcomeSection } from '../components/Home/WelcomeSection'
import FooterOutside from '../components/Layout/FooterOutside'
import { Navbar } from '../components/Navbar/Navbar'
import { SEO } from '../components/seo'
import { openRecallCompetitor, redirectToMeetingBaas } from '../utils/router'
import { BassTheFishPageContent } from './bass-the-fish'
import { MeetingBotAPIContent } from './lets-do-this'

const Home = () => {
    return (
        <main className="snap-mandatory">
            <SEO
                title="Universal Meeting Api(s) | aka Meeting Bots as a Service 🐟"
                description="Deploy Meeting Bots with transcription using one of two aggregator APIs."
                isHomePage={true}
                imagePath='UniversalTranscriptionApi'
            />
            <div className=" overflow-y-scroll h-screen min-h-screen min-w-screen max-w-screen overflow-x-hidden bg-neutral-50">
                <Navbar />
                <WelcomeSection
                    title1="Universal Meeting"
                    title2="API(s)"
                    title3=""
                    subtitle1="Two APIs can claim two be universal meeting APIs for now:"
                    subtitle2="Recall.ai (the 1st player), and Meeting Baas"
                    buttonName="Try free with Meeting BaaS 🐟"
                    onButtonClick={redirectToMeetingBaas}
                    secondButtonName="view Recall.ai"
                    onSecondButtonClick={openRecallCompetitor}
                />
                <MeetingBotAPIContent path={'transcription-api'}></MeetingBotAPIContent>
                {/* <HomeSpokeBot></HomeSpokeBot> */}
                <FeaturesSection />
                <LastSection />
                <BassTheFishPageContent path={'transcription-api'} showFooter={false}/>
            {/* <HomeSpokeBot></HomeSpokeBot> */}
                {/* <HomeSpokeBot></HomeSpokeBot> */}
                {/* <FeaturesSection /> */}
                {/* <LastSection /> */}
                <div className="snap-start min-w-screen max-w-screen overflow-x-hidden bg-neutral-900">
                    <FooterOutside />
                </div>
            </div>
        </main>
    )
}
export default Home
